module.exports = require("@gauzy/plugin-videos");